import * as yup from "yup";

export const validationSchema = yup.object().shape({
  currency: yup.string().trim().required("This field is required"),
  rate: yup.number().required("This field is required"),
});

export default validationSchema;
